<template>
  <b-modal id="EmployeeBranchInfo" scrollable size="lg" centered hide-footer>
    <template #modal-title>
      <h3>
        <img src="@/assets/images/establishment-roles.svg" class="icon-lg" />
        {{ $t("employee-branches-msgs.data") }}
      </h3>
    </template>
    <div class="row">
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="employeeBranchData.employeeNameCurrent"
        :title="$t('employeeName')"
        :imgName="'employees.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="employeeBranchData.employeePhoneWithCC"
        :title="$t('phoneNumber')"
        :imgName="'phone.svg'"
      />

      <DataLabelGroup
        :className="'col-lg-6'"
        :value="employeeBranchData.employeeCode"
        :title="$t('employeeCode')"
        :imgName="'number.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="employeeBranchData.branchNameCurrent"
        :title="$t('branchName')"
        :imgName="'branches.svg'"
      />

      <DataLabelGroup
        :className="'col-lg-6'"
        :value="employeeBranchData.branchRoleNameCurrent"
        :title="$t('setting.others.branchRolesMsgs.branchRole')"
        :imgName="'branch-roles.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="employeeBranchData.employeeWorkPlaceTypeNameCurrent"
        :title="$t('employeeWorkPlaceType')"
        :imgName="'type.svg'"
      />

      <DataLabelGroup
        :className="'col-lg-12'"
        :value="timeToLang(employeeBranchData.actionDateTime)"
        :title="$t('actionDateTime')"
        :imgName="'dateAndTime.svg'"
      />
    </div>
  </b-modal>
</template>

<script>
import DataLabelGroup from "@/components/general/DataLabelGroup.vue";
import { setDataMultiLang, timeToLang } from "@/utils/functions";

export default {
  name: "EmployeeBranchInfo",
  components: {
    DataLabelGroup,
  },
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["employeeBranchData"],
  methods: {
    timeToLang(time) {
      return timeToLang(time, this.language);
    },
    setDataMultiLang(lang, dataAr, dataEn) {
      return setDataMultiLang(lang, dataAr, dataEn);
    },
  },
  async created() {},
};
</script>

<style scoped lang="scss"></style>
